var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.319,
    height: 8.16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5589",
    "data-name": "Groupe 5589",
    transform: "translate(-1847 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "=",
    transform: "translate(1856.139 39.057)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_68",
    "data-name": "Ligne 68",
    x2: 16.319,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_69",
    "data-name": "Ligne 69",
    x2: 16.319,
    transform: "translate(0 8.16)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 29,
    height: 30,
    transform: "translate(1853 25)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1516",
    "data-name": "Ellipse 1516",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1847 14)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5588",
    "data-name": "Groupe 5588",
    transform: "translate(1858.305 25.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3503",
    "data-name": "Groupe 3503",
    transform: "translate(7.099 7.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5288",
    "data-name": "Trac\\xE9 5288",
    d: "M99.815,702.749a.551.551,0,0,1-.391-.942l9.639-9.636a.552.552,0,1,1,.781.781l-9.639,9.636a.546.546,0,0,1-.39.161Z",
    transform: "translate(-99.263 -692.01)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3504",
    "data-name": "Groupe 3504",
    transform: "translate(11.475 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5289",
    "data-name": "Trac\\xE9 5289",
    d: "M108.92,699.072c-.161,0-.325-.005-.488-.021a.552.552,0,0,1-.5-.6.563.563,0,0,1,.6-.5,4.194,4.194,0,0,0,3.373-1.212l2.743-2.744a4.271,4.271,0,0,0,0-6.033l-.31-.311a4.272,4.272,0,0,0-6.031,0l-2.744,2.742a4.229,4.229,0,0,0-1.215,3.375.552.552,0,0,1-.5.6.562.562,0,0,1-.6-.5,5.335,5.335,0,0,1,1.533-4.255l2.746-2.742a5.373,5.373,0,0,1,7.592,0l.311.312a5.375,5.375,0,0,1,0,7.593l-2.743,2.744a5.316,5.316,0,0,1-3.765,1.552Z",
    transform: "translate(-103.226 -685.3)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3505",
    "data-name": "Groupe 3505",
    transform: "translate(0 11.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5290",
    "data-name": "Trac\\xE9 5290",
    d: "M98.514,709.465a5.358,5.358,0,0,1-3.8-1.57l-.311-.311a5.365,5.365,0,0,1,0-7.591l2.741-2.744a5.346,5.346,0,0,1,4.255-1.536.552.552,0,0,1,.5.6.559.559,0,0,1-.6.5,4.238,4.238,0,0,0-3.377,1.216l-2.741,2.745a4.261,4.261,0,0,0,0,6.031l.311.311a4.273,4.273,0,0,0,6.031,0l2.747-2.745a4.234,4.234,0,0,0,1.213-3.376.552.552,0,1,1,1.1-.1,5.332,5.332,0,0,1-1.531,4.254l-2.748,2.744a5.344,5.344,0,0,1-3.794,1.57Z",
    transform: "translate(-92.832 -695.692)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.355348352fa45429fa720615bf29b30b.svg";
export { ForwardRef as ReactComponent };